import SelectAll from 'components/SelectAll';

const MultiSelectFilter = ({ onChange, options, selectedValues }) => {
  const handleChange = event => {
    onChange(event.map(item => item.value));
  };

  return (
    <SelectAll
      handleChange={handleChange}
      mapBy="label"
      trackBy="value"
      options={options}
      optionSelected={selectedValues?.map(value => ({
        label: options.find(option => option.value === value)?.label,
        value,
      }))}
    />
  );
};

export default MultiSelectFilter;
